<template>
  <div class="side-container__content">
    <div
      v-if="asideData.title || asideData.subtitle"
      class="side-container__header"
    >
      <p
        v-if="asideData.title"
        class="side-container__title -dark-"
      >
        {{ asideData.title }}
      </p>
      <p
        v-if="asideData.subtitle"
        class="side-container__subtitle"
      >
        {{ asideData.subtitle }}
      </p>
    </div>
    <div class="side-container__body -full-">
      <div class="side-container-field">
        <div class="side-container-field__list">
          <div class="side-container-field__item">
            <UiInput
              v-model.trim="name"
              title="Название команды"
              placeholder="Напишите название команды"
              :popup="validPopup(!$v.name.required, 'Обязательное поле')"
            />
          </div>
          <div class="side-container-field__item">
            <UiSelectFilter
              v-model="seniorCaptain"
              title="Старший капитан"
              placeholder="Укажите старшего капитана"
              :can-unset="true"
              unset-text="Без старшего капитана"
              unset-class=""
              :max-height="200"
              :option="seniorCaptainList"
            />
          </div>
          <div class="side-container-field__item">
            <UiSelectFilter
              v-model="captain"
              title="Капитан"
              placeholder="Укажите капитана"
              :can-unset="true"
              unset-text="Без капитана"
              unset-class=""
              :max-height="200"
              :option="captainList"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="side-container__footer -end-">
      <UiButton @click="editTeam">
        Сохранить
      </UiButton>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    asideObject: {
      type: Object,
      default: () => ({
        aside: {
          data: {
            team: {
              id: '',
              name: ''
            }
          },
          meta: {}
        }
      })
    }
  },
  data: () => ({
    name: '',
    captain: '',
    seniorCaptain: ''
  }),
  computed: {
    ...mapState('teamGroup', {
      teams: s => s.data.teams,
      settings: s => s.data.settings,
      loadedSetting: s => s.meta.loadedSetting,
      isSettingLoading: s => s.meta.isSettingLoading,
      captainList: s =>
        s.data.settings.captains
          .map(item => ({
            value: item.id,
            title: `${item.name} ${item.lastname}`
          }))
          .filter(item => item.value !== ''),
      seniorCaptainList: s =>
        s.data.settings.seniorCaptains
          .map(item => ({
            value: item.id,
            title: `${item.name} ${item.lastname}`
          }))
          .filter(item => item.value !== '')
    }),
    asideData() {
      return this.asideObject.aside ? this.asideObject.aside.data : {};
    },
    asideMeta() {
      return this.asideObject.aside ? this.asideObject.aside.meta : {};
    },
    team() {
      const team = this.teams.find(item => item.id === this.asideData.team.id);
      return team ? team : { captain: {} };
    }
  },
  watch: {
    isSettingLoading(loadState) {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: loadState
      });
    }
  },
  mounted() {
    this.initData();
    this.getSetting();

    if (this.isSettingLoading) {
      this.showLoader();
    }
  },
  methods: {
    ...mapActions('asides', ['closeAside', 'updateAsideMetaPath']),
    async initData() {
      await this.getTeam();

      this.name = this.asideData.team.name;
      if (this.team.captain) {
        this.captain = this.team.captain.id;
      }
      if (this.team.seniorCaptain) {
        this.seniorCaptain = this.team.seniorCaptain;
      }
    },
    async getTeam() {
      if (this.teams.find(item => item.id === this.asideData.team.id)) {
        return;
      }

      this.showLoader();
      const res = await this.$store.dispatch(
        'teamGroup/getTeamsData',
        this.asideData.team.id
      );
      this.unshowLoader();

      if (res.status !== 'success') {
        this.closeAside({ name: this.asideObject.aside.data.name });
      }
    },
    async getSetting() {
      if (!this.loadedSetting && !this.isSettingLoading) {
        await this.$store.dispatch('teamGroup/getTeamsSettings');
      }
    },
    showLoader() {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: true
      });
    },
    unshowLoader() {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: false
      });
    },
    async editTeam() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.showLoader();
      // Редактируем команду
      const res = await this.$store.dispatch('teamGroup/editTeam', {
        id: this.team.id,
        name: this.name,
        captain: this.captain !== undefined ? this.captain : '',
        seniorCaptain:
          this.seniorCaptain !== undefined ? this.seniorCaptain : ''
      });

      if (res.status === 'success') {
        this.closeAside({ name: this.asideObject.aside.data.name });
      }

      this.unshowLoader();
    },
    validPopup(isErr, text) {
      if (!this.$v.$dirty) {
        return;
      }
      if (isErr) {
        return { msg: text, error: true };
      }
    }
  },
  validations: {
    name: { required }
  }
};
</script>
